module.exports = __webpack_public_path__ + "images/Share.e4b2a3475e2160856e488499759e8c35.svg";